<mat-card class="experience-card" *ngIf="course" [class.error] = "loadError">
  <div class="title-thumbnail" (click)="goToAnalytics()">
    <div class="icon-container">
      <mat-icon *ngIf="course.is_multi">people</mat-icon>
      <mat-icon *ngIf="!course.is_multi">person</mat-icon>
      <mat-icon *ngIf="course.experience_type === '360'" svgIcon="content-360"></mat-icon>
    </div>
    <img mat-card-image [src]="(course.postermedia?.path || '/assets/wonda/background2_ld.jpg')" alt="">
  </div>
  <mat-card-content *loading="loadStatus">
    <div class="content-top"> 
      <div class="content-title" (click)="goToAnalytics()">
        {{ course.title }}
      </div>
      <experience-menu [course]="course" [hub]="hub"></experience-menu>

      
    </div>
    <div class="content-card-container" (click)="goToAnalytics()">
        <stat-card *ngFor="let stat of statsCards" [icon]="stat.icon" [label]="stat.label" [sublabel]="stat.sublabel"></stat-card>
    </div>
  </mat-card-content>
</mat-card>
